ready().then(function() {
    /*
     * There are some scroll indicators on the left and the right when you are able to scroll or not - we add them by CSS psuedo elements to add this custom twist
     */

    const scrollIndicator = $('.has-scroll-indicators');

    const toggleScrollIndicators = () => {

        if (scrollIndicator.length > 0) {

            $(scrollIndicator).each(function() {

                $(this).on('scroll',function() {

                    var scrollLeftPos = $(this).scrollLeft();
                    var scrollVisualWidth = $(this).width();
                    var scrollWidth = $(this)[0].scrollWidth;
                    const perc = 100 * scrollLeftPos / (scrollWidth - scrollVisualWidth);

                    if(perc <= 10) {
                        $(this).addClass('has-startpos');
                    } else {
                        $(this).removeClass('has-startpos');
                    }

                    if(perc >= 90) {
                        $(this).addClass('has-endpos');
                    } else {
                        $(this).removeClass('has-endpos');
                    }
                });
            });
        }
    }

    toggleScrollIndicators();
});
